import { useState } from 'react';

const videos = [
  { 
    url: 'https://cdn.pixabay.com/video/2024/06/26/218309_tiny.mp4',
    prompt: '"Magical glowing mushrooms in a dark enchanted forest with bioluminescent lighting"'
  },
  { 
    url: 'https://cdn.pixabay.com/video/2024/09/01/229254_tiny.mp4',
    prompt: '"Macro shot of ice crystals forming with intricate frozen water structures"'
  },
  { 
    url: 'https://cdn.pixabay.com/video/2023/10/10/184449-873483817_tiny.mp4',
    prompt: '"Cozy interior room with large windows overlooking autumn forest with colorful fall foliage"'
  },
  { 
    url: 'https://cdn.pixabay.com/video/2024/03/24/205533-927335725_tiny.mp4',
    prompt: '"Close-up of fire flames burning with intense orange and red colors"'
  },
  { 
    url: 'https://cdn.pixabay.com/video/2024/03/04/202929-919288883_tiny.mp4',
    prompt: '"Aerial view from airplane window looking at ocean coastline and beach from above"'
  },
  { 
    url: 'https://cdn.pixabay.com/video/2022/12/19/143547-782758266_large.mp4',
    prompt: '"Magical sunlit forest with rays of light streaming through misty trees"'
  },
  { 
    url: 'https://cdn.pixabay.com/video/2023/07/20/172491-847499843_tiny.mp4',
    prompt: '"Hand holding vintage alarm clock with warm golden lighting"'
  },
  { 
    url: 'https://cdn.pixabay.com/video/2023/11/13/188933-884185295_large.mp4',
    prompt: '"Person inside a cave looking out at dramatic sky with light rays"'
  },
  { 
    url: 'https://cdn.pixabay.com/video/2022/12/30/144731-785264996_tiny.mp4',
    prompt: '"Misty forest with tall pine trees in foggy atmospheric conditions"'
  },
  { 
    url: 'https://cdn.pixabay.com/video/2023/08/15/176072-854875280_tiny.mp4',
    prompt: '"Sparks and embers flying in the dark with orange glowing particles"'
  },
  { 
    url: 'https://cdn.pixabay.com/video/2023/08/17/176527-855920754_tiny.mp4',
    prompt: '"Astronaut in spacesuit standing on Mars-like red desert planet surface"'
  },
  { 
    url: 'https://cdn.pixabay.com/video/2023/12/01/191569-890528360_tiny.mp4',
    prompt: '"Winter scene with frost crystals on window and snowy pine tree outside"'
  },
];

const VideoGenSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isGenerating, setIsGenerating] = useState(false);

  const handleGenerate = () => {
    if (isGenerating) return;
    
    setIsGenerating(true);
    
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % videos.length);
      setIsGenerating(false);
    }, 2000);
  };

  const current = videos[currentIndex];

  return (
    <div id="video-gen-section" className="mb-16 sm:mb-24">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
        <div>
          <div className="glass-panel rounded-xl sm:rounded-[2rem] p-4 sm:p-6 relative overflow-hidden">
            <div className="bg-white/5 rounded-lg sm:rounded-xl p-3 sm:p-4 mb-3 sm:mb-4">
              <p className="text-white/40 text-xs sm:text-sm font-mono">{current.prompt}</p>
            </div>
            <div className="aspect-video rounded-lg sm:rounded-xl overflow-hidden bg-gradient-to-br from-primary/20 to-amber-900/20 relative">
              {isGenerating && (
                <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/60 z-10">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin mb-3 sm:mb-4"></div>
                  <p className="text-white/70 text-xs sm:text-sm">Generating your video...</p>
                </div>
              )}
              <video 
                key={currentIndex}
                autoPlay
                loop
                muted
                playsInline
                className={`w-full h-full object-cover transition-opacity duration-300 ${isGenerating ? 'opacity-30' : 'opacity-100'}`}
              >
                <source src={current.url} type="video/mp4" />
              </video>
            </div>
            <div className="flex items-center justify-between mt-3 sm:mt-4">
              <span className="text-[10px] sm:text-xs text-white/40 font-mono">Generated in 1.2s</span>
            </div>
          </div>
        </div>
        <div>
          <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
            <div className="flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-full bg-primary/20">
              <span className="material-symbols-outlined text-primary text-xl sm:text-2xl">movie</span>
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-white">AI Video Generation</h3>
          </div>
          <p className="text-white/70 mb-4 sm:mb-6 text-sm sm:text-lg">
            Create cinematic video sequences from text or images. Our motion synthesis engine produces smooth, coherent animations with realistic physics.
          </p>
          <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
            <li className="flex items-center gap-2 sm:gap-3 text-white/60 text-sm">
              <span className="material-symbols-outlined text-primary text-sm">check_circle</span>
              Text-to-video up to 60 seconds
            </li>
            <li className="flex items-center gap-2 sm:gap-3 text-white/60 text-sm">
              <span className="material-symbols-outlined text-primary text-sm">check_circle</span>
              Image-to-video animation
            </li>
            <li className="flex items-center gap-2 sm:gap-3 text-white/60 text-sm">
              <span className="material-symbols-outlined text-primary text-sm">check_circle</span>
              4K resolution with 60fps output
            </li>
          </ul>
          <button 
            onClick={handleGenerate}
            disabled={isGenerating}
            className="btn-glow flex h-10 sm:h-12 items-center justify-center rounded-full bg-primary px-6 sm:px-8 text-xs sm:text-sm font-bold text-background-dark disabled:opacity-50"
          >
            {isGenerating ? 'Generating...' : 'Generate'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoGenSection;
